module.exports = __webpack_public_path__ + "img/ico09.e7ffd473.svg";